import { FC, PropsWithChildren } from 'react';
import {
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { ROUTES } from 'config';
import { useMe } from 'state/Administrators';

export const EmployeesLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const { hasViewPermission } = useMe();

  return (
    <Stack gap={2}>
      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('exportFileName.employees'),
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              ...(hasViewPermission(['employees'])
                ? [
                    {
                      key: 'employees' as const,
                      label: t('exportFileName.employees'),
                      url: ROUTES.employees.list,
                      isActive: path === ROUTES.employees.list,
                    },
                  ]
                : []),
              ...(hasViewPermission(['groups'])
                ? [
                    {
                      key: 'groups' as const,
                      label: t('menu.groups'),
                      url: ROUTES.employeeGroups.list,
                      isActive: path === ROUTES.employeeGroups.list,
                    },
                  ]
                : []),
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
